"use strict";

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck"),
    _classCallCheck3 = _interopRequireDefault(_classCallCheck2),
    _createClass2 = require("babel-runtime/helpers/createClass"),
    _createClass3 = _interopRequireDefault(_createClass2),
    _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn"),
    _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2),
    _inherits2 = require("babel-runtime/helpers/inherits"),
    _inherits3 = _interopRequireDefault(_inherits2),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _reactDom = require("react-dom"),
    _reactDom2 = _interopRequireDefault(_reactDom),
    _propTypes = require("prop-types"),
    _propTypes2 = _interopRequireDefault(_propTypes),
    Slider = function (e) {
  function t() {
    var e, r, a, n;

    _classCallCheck3["default"](this, t);

    for (var o = arguments.length, l = Array(o), i = 0; o > i; i++) {
      l[i] = arguments[i];
    }

    return r = a = _possibleConstructorReturn3["default"](this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), a.state = {
      dragStart: 0,
      dragStartTime: new Date(),
      index: 0,
      lastIndex: 0,
      mouseOver: !1,
      transition: !1
    }, a.handleDragStart = function (e, t) {
      var r = a.getDragX(e, t);
      a.onMouseOver(), a.setState({
        dragStart: r,
        dragStartTime: new Date(),
        transition: !1,
        slideWidth: _reactDom2["default"].findDOMNode(a.slider).offsetWidth
      });
    }, a.handleDragMove = function (e, t) {
      var r = a.state,
          n = r.dragStart,
          o = r.lastIndex,
          l = r.slideWidth,
          i = a.getDragX(e, t),
          s = n - i,
          u = s / l,
          d = o + u,
          c = 30;
      Math.abs(s) > c && (e.stopPropagation(), e.preventDefault()), a.setState({
        index: d
      });
    }, a.handleDragEnd = function () {
      var e = a.props,
          t = e.childCount,
          r = e.children,
          n = a.state,
          o = n.dragStartTime,
          l = n.index,
          i = n.lastIndex;
      a.onMouseOut();
      var s = new Date().getTime() - o.getTime(),
          u = i - l,
          d = Math.round(u / s * 1e4),
          c = Math.round(l);
      Math.abs(d) > 5 && (c = 0 > d ? i + 1 : i - 1), 0 > c ? c = 0 : c >= (t || r.length) && (c = (t || r.length) - 1), a.setState({
        dragStart: 0,
        index: c,
        lastIndex: c,
        transition: !0
      });
    }, a.goToSlide = function (e, t) {
      var r = a.props,
          n = r.childCount,
          o = r.children,
          l = r.loop;
      t && (t.preventDefault(), t.stopPropagation()), 0 > e ? e = l ? (n || o.length) - 1 : 0 : e >= (n || o.length) && (e = l ? 0 : (n || o.length) - 1), a.setState({
        index: e,
        lastIndex: e,
        transition: !0
      });
    }, a.renderNav = function () {
      for (var e = a.props, t = e.children, r = e.childCount, n = a.state.lastIndex, o = [], l = function l(e) {
        var t = e === n ? "Slider-navButton Slider-navButton--active" : "Slider-navButton";
        o.push(_react2["default"].createElement("button", {
          className: t,
          key: "slider-navigation--" + e,
          onClick: function onClick(t) {
            return a.goToSlide(e, t);
          }
        }));
      }, i = 0; i < (r || t.length); i++) {
        l(i);
      }

      return _react2["default"].createElement("div", {
        className: "Slider-nav"
      }, o);
    }, a.renderArrows = function () {
      var e = a.props,
          t = e.children,
          r = e.loop,
          n = e.showNav,
          o = e.childCount,
          l = a.state.lastIndex,
          i = n ? "Slider-arrows" : "Slider-arrows Slider-arrows--noNav";
      return _react2["default"].createElement("div", {
        className: i
      }, r || l > 0 ? _react2["default"].createElement("button", {
        className: "Slider-arrow Slider-arrow--left",
        onClick: function onClick(e) {
          return a.goToSlide(l - 1, e);
        }
      }) : null, r || l < (o || t.length) - 1 ? _react2["default"].createElement("button", {
        className: "Slider-arrow Slider-arrow--right",
        onClick: function onClick(e) {
          return a.goToSlide(l + 1, e);
        }
      }) : null);
    }, a.initAutoplay = function () {
      a.props.autoplay && (a.autoplayInterval = setInterval(function () {
        a.goToSlide(a.state.lastIndex + 1);
      }, a.props.autoplaySpeed));
    }, a.onMouseOver = function () {
      a.autoplayInterval && clearInterval(a.autoplayInterval);
    }, a.onMouseOut = function () {
      a.initAutoplay();
    }, n = r, _possibleConstructorReturn3["default"](a, n);
  }

  return _inherits3["default"](t, e), _createClass3["default"](t, [{
    key: "componentWillMount",
    value: function value() {
      var e = this.props.selected;
      this.setState({
        index: e,
        lastIndex: e
      });
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.initAutoplay();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function value(e) {
      var t = this.props.selected;
      t !== e.selected && this.goToSlide(e.selected);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.onMouseOver();
    }
  }, {
    key: "getDragX",
    value: function value(e, t) {
      return t ? e.touches[0].pageX : e.pageX;
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
          t = this.props,
          r = t.children,
          a = t.showArrows,
          n = t.showNav,
          o = t.childCount,
          l = this.state,
          i = l.index,
          s = l.transition,
          u = {
        width: 100 * (o || r.length) + "%",
        transform: "translateX(" + -1 * i * (100 / (o || r.length)) + "%)"
      },
          d = s ? "Slider-slides Slider-slides--transition" : "Slider-slides";
      return _react2["default"].createElement("div", {
        className: "Slider",
        ref: function ref(t) {
          e.slider = t;
        }
      }, a ? this.renderArrows() : null, n ? this.renderNav() : null, _react2["default"].createElement("div", {
        className: "Slider-inner",
        onTouchStart: function onTouchStart(t) {
          return e.handleDragStart(t, !0);
        },
        onTouchMove: function onTouchMove(t) {
          return e.handleDragMove(t, !0);
        },
        onTouchEnd: function onTouchEnd() {
          return e.handleDragEnd(!0);
        },
        onMouseOver: this.onMouseOver,
        onMouseOut: this.onMouseOut
      }, _react2["default"].createElement("div", {
        className: d,
        style: u
      }, "function" == typeof r ? r(this.goToSlide) : r)));
    }
  }]), t;
}(_react.Component);

Slider.displayName = "Slider", Slider.defaultProps = {
  autoplay: !1,
  autoplaySpeed: 7e3,
  childCount: null,
  loop: !1,
  selected: 0,
  showArrows: !0,
  showNav: !0
}, Slider.propTypes = {
  autoplay: _propTypes2["default"].bool,
  autoplaySpeed: _propTypes2["default"].number,
  childCount: _propTypes2["default"].number,
  loop: _propTypes2["default"].bool,
  selected: _propTypes2["default"].number,
  showArrows: _propTypes2["default"].bool,
  showNav: _propTypes2["default"].bool
}, exports["default"] = Slider;